export const GEO_ID = 'address';
export const PRICE_ID = 'price-and-deal-terms';
export const PUBLISH_TERMS_ID = 'ad-placing-terms';
export const SERVICES_SLIDER_ID = 'placing-services-slider';
